module.exports = __webpack_public_path__ + "static/media/Mail.87a44b06.svg";